/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import SimilaritySearchDialog from '@Pages/RetroSynthesis/SimilaritySearch/SimilaritySearchDialog';
import {
  isSimilarityLoading as isSimilarityLoadingSelector,
  isResultsLoading as isResultsLoadingSelector,
  databaseId as databaseIdSelector,
  reactions as reactionsSelector,
  totalItems as totalItemsSelector,
  error as errorSelector,
} from './selectors';
import {
  cleanState as cleanStateAction,
  fetchSimilaritySearch as fetchSimilaritySearchAction,
  loadSimilaritySearchResults as loadSimilaritySearchResultsAction,
  submitSimilarSubstance as submitSimilarSubstanceAction,
} from './actions';
import { closeFindPreparationsSimilaritySearchDialog as closeFindPreparationsSimilaritySearchDialogAction } from './dialogActions';

export function SimilaritySearchDialogContainer({
  fetchSimilaritySearch,
  loadSimilaritySearchResults,
  closeFindPreparationsSimilaritySearchDialog,
  cleanState,
  submitSimilarSubstance,
  isSimilarityLoading,
  isResultsLoading,
  reactions,
  totalItems,
  error,
  databaseId,
  // From own props
  substance,
  context,
  originalDatabaseId,
}) {
  useEffect(() => {
    fetchSimilaritySearch({ substance, originalDatabaseId });
    return () => {
      cleanState();
    };
  }, []);

  useEffect(() => {
    if (totalItems > 0 && isEmpty(reactions)) {
      loadSimilaritySearchResults();
    }
  }, [totalItems, reactions]);

  return (
    <SimilaritySearchDialog
      title="No preparation available. Please select an alternative target from below"
      onCancel={closeFindPreparationsSimilaritySearchDialog}
      onLoadMore={() => loadSimilaritySearchResults()}
      similarResults={reactions}
      isSimilarityLoading={isSimilarityLoading}
      isResultsLoading={isResultsLoading}
      totalItems={totalItems}
      error={error}
      onSubmitSubstance={async (similarSubstance) => {
        await submitSimilarSubstance({
          substance: similarSubstance,
          databaseId,
          context,
        });
        closeFindPreparationsSimilaritySearchDialog();
      }}
    />
  );
}

SimilaritySearchDialogContainer.propTypes = {
  fetchSimilaritySearch: PropTypes.func,
  loadSimilaritySearchResults: PropTypes.func,
  closeFindPreparationsSimilaritySearchDialog: PropTypes.func,
  cleanState: PropTypes.func,
  submitSimilarSubstance: PropTypes.func,
  isSimilarityLoading: PropTypes.bool,
  isResultsLoading: PropTypes.bool,
  reactions: PropTypes.array,
  totalItems: PropTypes.number,
  error: PropTypes.object,
  databaseId: PropTypes.string,
  substance: PropTypes.object,
  context: PropTypes.string,
  originalDatabaseId: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    isSimilarityLoading: isSimilarityLoadingSelector(state),
    isResultsLoading: isResultsLoadingSelector(state),
    databaseId: databaseIdSelector(state),
    reactions: reactionsSelector(state),
    totalItems: totalItemsSelector(state),
    error: errorSelector(state),
  };
}

const mapDispatchToProps = {
  fetchSimilaritySearch: fetchSimilaritySearchAction,
  loadSimilaritySearchResults: loadSimilaritySearchResultsAction,
  submitSimilarSubstance: submitSimilarSubstanceAction,
  cleanState: cleanStateAction,
  closeFindPreparationsSimilaritySearchDialog: closeFindPreparationsSimilaritySearchDialogAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SimilaritySearchDialogContainer);
